import { waLink } from "../../lib/site";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={waLink("Hi! I'd love to know more about your sarees.")}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-widget"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp/40 animate-ping" aria-hidden />
      <span className="relative flex items-center gap-3 bg-whatsapp text-white pr-5 pl-4 py-3.5 rounded-full shadow-[0_20px_50px_-20px_rgba(37,211,102,0.7)] group-hover:scale-[1.04] transition-transform">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden>
          <path d="M19.11 17.21c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.13-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.64 1.12 2.82.13.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.56.58.65.21 1.25.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.12-.25-.18-.52-.31zM12.05 21.5h-.04a9.5 9.5 0 0 1-4.83-1.32l-.35-.21-3.59.94.96-3.5-.23-.36a9.5 9.5 0 1 1 8.08 4.45zM20.52 3.49A11.5 11.5 0 0 0 1.84 17.61L0 24l6.55-1.72a11.45 11.45 0 0 0 5.49 1.4h.01A11.5 11.5 0 0 0 20.52 3.49z"/>
        </svg>
        <span className="text-sm font-medium tracking-wide hidden sm:inline">WhatsApp</span>
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
